export default __webpack_public_path__ + "static/bg-ai-solution-with-roadmap-0f4e5cbb72d5f93dd60249a3de9b629d.jpg";